<template>
	<nav v-if="displayableOptions.length" class="new-event-options" aria-label="Opcoes do evento">
		<div
			v-for="option in displayableOptions"
			:key="option.id"
			class="new-event-options__slot"
		>
			<button
				type="button"
				class="new-event-options__item"
				:class="[resourceClassFor(option), {'new-event-options__item--active': isActiveOption(option)}]"
				:aria-pressed="isActiveOption(option) ? 'true' : 'false'"
				@click="handleSelect(option)"
			>
				<img :src="iconFor(option)" :alt="labelFor(option)">
				<span>{{labelFor(option)}}</span>
			</button>
		</div>
	</nav>
</template>

<script>
import Options from '../../enums/Options';

const OPTION_ICON_BASE = '/static/buttons/new';

export default {
	props: {
		options: {
			type: Array,
			default: () => [],
		},
		event: {
			type: Object,
			required: true,
		},
		activeResource: {
			type: String,
			default: '',
		},
	},
	computed: {
		displayableOptions() {
			return this.options
				.filter(option => this.hasDisplayLanguage(option))
				.sort((a, b) => a.placementOrder - b.placementOrder);
		},
	},
	methods: {
		resourceFor(option) {
			const optionData = option && option.option ? option.option : {};
			return String(optionData.resource || '').trim();
		},
		hasDisplayLanguage(option) {
			if (!option.displayLanguages || !option.displayLanguages.length) return true;
			return Boolean(option.displayLanguages.find(language => language.id === this.$store.state.language.id));
		},
		iconFor(option) {
			const optionData = option && option.option ? option.option : {};
			return `${OPTION_ICON_BASE}/${optionData.buttonFileName}.svg`;
		},
		labelFor(option) {
			const optionData = option && option.option ? option.option : {};
			return optionData.name || '';
		},
		isActiveOption(option) {
			return this.activeResource === this.resourceFor(option);
		},
		resourceClassFor(option) {
			return `new-event-options__item--${this.resourceFor(option)}`;
		},
		handleSelect(option) {
			const resource = this.resourceFor(option);
			if (resource === Options.EVENT_PROMOTER_WEBSITE.name) {
				this.openEventWebsite();
				return;
			}
			this.$emit('select', resource);
		},
		openEventWebsite() {
			if (!this.event || !this.event.site) return;
			const openedWindow = window.open(this.event.site, '_blank', 'noopener');
			if (openedWindow) openedWindow.opener = null;
		},
	},
};
</script>

<style scoped lang="scss">
.new-event-options {
	display: flex;
	flex-wrap: wrap;
	gap: 0;}

.new-event-options__slot {
	display: flex;
	flex: 0 0 120px;
	margin-right: 7px;
}

.new-event-options__slot:last-child {
	margin-right: 0;
}

.new-event-options__item {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	box-sizing: border-box;
	width: 100%;
	min-height: 125px;
	padding: 16px 8px 12px;
	border: 1.5px solid #d9d9d9;
	border-radius: 25px;
	background: #ffffff;
	color: #5da3bd;
	cursor: pointer;
	font-family: inherit;
	font-size: 15px;
	font-weight: 500;
	line-height: 18px;
	text-align: center;
	text-decoration: none;
	transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

.new-event-options__item:hover {
	border-color: #66acc6;
	box-shadow: 3px 3px 10px rgba(0, 0, 0, .08);
	color: #5da3bd;
	transform: translateY(-2px);
}

.new-event-options__item--active,
.new-event-options__item--active:hover {
	background: #5da3bd;
	border-color: #d9d9d9;
	color: #ffffff;
}

.new-event-options__item--active img {
	filter: brightness(0) invert(1);
}

.new-event-options__item img {
	display: block;
	width: 48px;
	height: 48px;
	margin-bottom: 5px;
	object-fit: contain;
}

.new-event-options__item span {
	display: block;
	max-width: 82px;
}

.new-event-options__item--hotel-reservation img {
	width: 40px;
	height: 40px;
	margin-top: 2px;
	margin-bottom: 8px;
}

.new-event-options__item--flight-request img {
	width: 50px;
	height: 50px;
	margin-top: -1px;
	margin-bottom: 4px;
}

.new-event-options__item--transfer img {
	width: 48px;
	height: 47px;
	margin-bottom: 5px;
}

.new-event-options__item--local-tour img {
	width: 54px;
	height: 41px;
	margin-top: 2px;
	margin-bottom: 9px;
}

.new-event-options__item--pre-post-tour img {
	width: 64px;
	height: 44px;
	margin-top: 1px;
	margin-bottom: 8px;
}

.new-event-options__item--about-brazil img,
.new-event-options__item--destination-info img {
	width: 50px;
	height: 49px;
	margin-bottom: 5px;
}

.new-event-options__item--web-site-event-promoter img {
	width: 45px;
	height: 45px;
	margin-top: 1px;
	margin-bottom: 8px;
}

@media (max-width: 900px) {
	.new-event-options {
		flex-wrap: nowrap;
		gap: 1.5%;
		max-width: none;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		padding: 5px 0px;
		scrollbar-width: none;
	}

	.new-event-options__slot {
		flex: 0 0 30%;
		margin-right: 0;
	}

	.new-event-options__item {
		min-height: 112px;
		padding: 18px 10px 12px;
		font-size: 13px;
		line-height: 15px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/event/EventOptions.vue